
import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import ProductRecord from "./ProductRecord";

@Component
export default class CellOperations extends Vue {
  @Prop()
  record!: ProductRecord;

  get NewRow() {
    if (this.record) {
      return this.record.NewRowRecord;
    }
    return false;
  }
  acceptEdit() {
    this.$emit("accept");
  }
  cancelEdit() {
    this.$emit("cancel");
  }

  deleteProduct() {
    this.$emit("delete");
  }
}
